import { ShortlandMapper } from "@/data/persistences/mappers/ShortlandMapper";
import { ShortlandRepositoryInterface } from "@/data/persistences/repositories/contracts/ShortlandRepositoryInterface";
import { ShortlandEntities } from "@/domain/entities/Shortland";
import { Endpoints } from "../../misc/Endpoints";
import ApiService from "../../services/ApiService";

export class ShortlandApiRepository implements ShortlandRepositoryInterface {
  private service: ApiService;
  private mapper: ShortlandMapper;
  private endpoints: Endpoints;

  constructor(
    service: ApiService,
    mapper: ShortlandMapper,
    endpoints: Endpoints
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getShortlandList(
    page: number,
    limit: number,
    startDate: string,
    endDate: string,
    search: string
  ): Promise<ShortlandEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getShortlandList(page, limit, startDate, endDate, search),
      {}
    );
    return this.mapper.convertListShortlandListDataFromApi(resp);
  }
}
